import React from "react";

import { ISnippet, ICustomData, IBasicText, IBasicMedia } from "../../../../interfaces";
import { LocalInfo, FormValProps, State } from "../../../utils/where-to-buy-form/interfaces";
import { COMPONENTS } from "../../../../constants";
import WhereToBuyForm, { getLocalInfo } from "../../../utils/where-to-buy-form";
import { setStorage, getStorage } from "../../../../localStorage.service";
import CmsMarkdown from "../../../basic/cms-markdown";
import { guid } from "../../../../utils";

const FORM_STATE_LOCAL_DETAILS = "localDetails";
const FORM_STATE_RESULT = "result";

type FormState = "localDetails" | "result";

const LOCAL_STORAGE_KEY = "localInfo";

class ColorOptionsLookup extends React.Component<ISnippet, State> {
  snippet: ISnippet;
  snippetData: ICustomData;
  formContentLayouts: object = {};
  backgroundImage: IBasicMedia;
  defaultFormStateValues: FormValProps = {
    btnHover: "",
    btnText: "",
    btnType: "",
    content: null
  };

  constructor(props) {
    super(props);
    this.snippet = this.props;
    this.state = {
      zipcode: undefined,
      country: undefined,
      formStateVals: {
        ...this.defaultFormStateValues
      },
      localInfo: null,
      loading: false,
      error: null
    };

    this.snippetData = this.snippet?.data?.attributes?.layout.find((item) => {
      return item.__typename === COMPONENTS.CUSTOM_DATA;
    }) as ICustomData;

    this.snippet?.data?.attributes?.layout.forEach((item) => {
      if (item.__typename != COMPONENTS.CUSTOM_DATA) {
        this.formContentLayouts[item.name] = item;
      }
    });

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleZipcodeChange = this.handleZipcodeChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
    this.changeLocation = this.changeLocation.bind(this);
  }

  getProduct(color, name) {
    const products = color.Products.filter((product) => {
      return Object.keys(product)
        .map((key) => key.toLowerCase())
        .includes(name.toLowerCase());
    });
    return { ...color, Products: products };
  }

  getProducts() {
    const colors = this.state.localInfo.colors;
    const product = this.snippet.custom_data["product"];
    return colors
      .map((color) => this.getProduct(color, product))
      .filter((color) => color.Products.length > 0)
      .map((color) => {
        const name = color.ColorName;
        const photo = color.Products.flatMap((product) => Object.values(product));
        return { name: name, photo: photo[0].Photos[0] };
      });
  }

  async componentWillMount() {
    const cachedLocalInfo = getStorage(LOCAL_STORAGE_KEY);
    if (cachedLocalInfo?.colors !== undefined) {
      this.setState({ localInfo: cachedLocalInfo });
    } else {
      await this.handleSubmit(new Event(null));
    }
  }

  async componentDidMount() {
    const cachedLocalInfo = getStorage(LOCAL_STORAGE_KEY);
    this.setState({ loading: false });
    if (this.isEmptyObject(cachedLocalInfo)) {
      this.setFormState(FORM_STATE_LOCAL_DETAILS);
    } else {
      this.setState({ localInfo: cachedLocalInfo });
      this.setFormState(FORM_STATE_RESULT);
    }
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ loading: true });
    const localInfo = await getLocalInfo(this.state.zipcode, this.state.country);
    if (localInfo?.companyId) {
      const colorLookupUrl = `${process.env.FUNCTIONS_URL}.netlify/functions/netsuite?script=74&deploy=1&compid=605399&h=55702bdd364d1c3f3cde&customerID=${localInfo.companyId}&_=1619030336442`;
      await fetch(colorLookupUrl)
        .then((response) => response.text())
        .then((responseData) => {
          let data = {};
          try {
            let jsonData = JSON.parse(responseData);
            if (jsonData && typeof jsonData === "object") {
              localInfo.colors = jsonData;
              this.setState({ localInfo: localInfo, loading: false });
              setStorage(LOCAL_STORAGE_KEY, localInfo);
            }
          } catch (err) {
            console.log(err);
          }
        });
      this.setFormState(FORM_STATE_RESULT);
      this.forceUpdate();
    }
  }

  handleZipcodeChange(event) {
    this.setState({ zipcode: event.target.value });
  }

  handleCountryChange(event) {
    this.setState({ country: event.target.value });
  }

  isEmptyObject(object: object) {
    return JSON.stringify(object) === JSON.stringify({});
  }

  setFormState(state: FormState) {
    const { content, ...otherProps } = this.snippetData.data[state];

    this.setState({
      formStateVals: {
        ...otherProps,
        content: this.formContentLayouts[content]
      }
    });
  }

  changeLocation() {
    this.setState({
      formStateVals: {
        ...this.defaultFormStateValues
      },
      localInfo: null
    });
    this.setFormState(FORM_STATE_LOCAL_DETAILS);
    setStorage(LOCAL_STORAGE_KEY, {});
  }

  renderColors(products) {
    return (
      <div className="color-grid">
        {this.getProducts().map((color, i) => {
          return (
            <div key={`color${i}`}>
              <img src={color.photo} />
              <p>{color.name}</p>
            </div>
          );
        })}
      </div>
    );
  }

  render() {
    const { btnHover, btnText, btnType, content } = this.state.formStateVals;
    const hasColors =
      this.state.localInfo && this.state.localInfo.colors && this.state.localInfo.colors.length > 0;
    const products = hasColors ? this.getProducts() : [];

    return (
      <div className="color-options-lookup-container">
        <div className="container-lg p-responsive color-options-lookup md-h2-thin">
          {this.state.localInfo == null ? (
            <div>
              {content == null ? null : (
                <CmsMarkdown key={guid()} content={content} elementClasses={{ p: "f3" }} />
              )}
              {this.state.error && <div className="error">{this.state.error}</div>}
              <WhereToBuyForm
                buttonText={btnText}
                onSubmit={this.handleSubmit}
                onZipcodeChange={this.handleZipcodeChange}
                onCountryChange={this.handleCountryChange}
                loading={this.state.loading}
                className={`${btnType} ${btnHover} flex-justify-center`}
              />
            </div>
          ) : (
            <div>
              {products.length > 0 && (
                <>
                  <CmsMarkdown
                    key={guid()}
                    content={content}
                    bindValues={this.state.localInfo}
                    className="clearfix"
                  />
                  {this.renderColors(products)}
                </>
              )}
              {products.length === 0 && (
                <>
                  <CmsMarkdown
                    key={guid()}
                    content={{
                      __typename: COMPONENTS.MARKDOWN,
                      text: "## Color Options",
                      id: "20",
                      align_text: "center",
                      name: "result-content"
                    }}
                    elementClasses={{ p: "f3" }}
                  />
                  <p className="text-center">
                    <a href="#where-to-buy">Contact your local supplier for color availability</a>
                  </p>
                </>
              )}
              <p className="text-center">
                {this.state.localInfo.zipcode}*{" "}
                <button className="btn-link" onClick={this.changeLocation}>
                  (Change Location)
                </button>
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ColorOptionsLookup;
